/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable react/jsx-filename-extension */
import { useState } from "react";

import { useDisclosure } from "@chakra-ui/react";

import createProvider from "./createProvider";

export type Drawer = {
  isOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
  highlightBlockId: string;
  setHighlightBlockId: (highlightBlockId: string) => void;
};

const initialData = {
  isOpen: false,
  onOpen: () => {},
  onClose: () => {},
  highlightBlockId: "",
  setHighlightBlockId: () => {},
};

function useDrawer() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [highlightBlockId, setHighlightBlockId] = useState("");

  return {
    isOpen,
    onOpen,
    onClose: () => {
      setHighlightBlockId("");
      onClose();
    },
    highlightBlockId,
    setHighlightBlockId: (id: string) => {
      setHighlightBlockId(id);
      onOpen();
    },
  };
}

const createDrawerProvider = () => createProvider<Drawer, Record<never, never>>(initialData, useDrawer);
export default createDrawerProvider;
